export const eligibilitiesMapping = {
  Disability: [
    "Developmental Disability",
    "Disabled",
    "Learning Disability",
    "Intellectual Disability",
    "Visual Impairment",
    "Limited Mobility",
    "Deaf or Hard of Hearing",
  ],
  "Families with children below 18 years old": [
    "Families with children below 18 years old",
  ],
  "Experiencing Homelessness": ["Experiencing Homelessness"],
  Immigrants: ["Immigrants", "Undocumented"],
  "LGBTQ+": ["LGBTQ+", "Transgender and Gender Non-Conforming"],
  "Mental Health/Substance Use": ["Mental Illness", "Substance Dependency"],
  "Re-Entry": ["Re-Entry", "In Jail"],
  "I am a Senior": ["I am a Senior"],
  "Transitional Aged Youth (TAY)": [
    "Transitional Aged Youth (TAY)",
    "Teens (13-18 years old)",
  ],
  "Trauma Survivors": [
    "Trauma Survivors",
    "Abuse or Neglect Survivors",
    "Domestic Violence Survivors",
    "PTSD",
  ],
  Veterans: ["Veterans"],
};

export const categoriesMapping = {
  "Basic Needs & Shelter": ["Basic Needs & Shelter"],
  Employment: ["Employment"],
  "Eviction Prevention": ["Eviction Prevention"],
  "Health & Medical": ["Health & Medical"],
  "Housing & Rental Assistance": ["Housing & Rental Assistance"],
  Legal: ["Legal"],
};
